import { useFormContext } from "../../../contexts/form-context";
import { IconButtonProps, IconButton } from "@mui/material";
import useStore from "../../../hooks/use-store";

export default function FormIconButton({
    disabled,
    children,
    ...props
}: IconButtonProps) {
    const form = useFormContext();
    
    const [isSubmitting] = useStore(form.store, state => [state.isSubmitting]);

    return <IconButton disabled={disabled || isSubmitting || form.disabled} {...props}>{children}</IconButton>
}